import { render, staticRenderFns } from "./ClassesJoin.vue?vue&type=template&id=3b05110e&scoped=true&"
import script from "./ClassesJoin.vue?vue&type=script&lang=js&"
export * from "./ClassesJoin.vue?vue&type=script&lang=js&"
import style0 from "./ClassesJoin.vue?vue&type=style&index=0&id=3b05110e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05110e",
  null
  
)

export default component.exports